import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Gender: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10.5" cy="6.5" r="4.5" stroke={color} strokeWidth="2" />
      <circle cx="13.5" cy="17.5" r="4.5" stroke={color} strokeWidth="2" />
      <path d="M16.5 14L22 8.5" stroke={color} strokeWidth="2" />
      <path
        d="M0.792893 14.7929C0.402369 15.1834 0.402369 15.8166 0.792893 16.2071C1.18342 16.5976 1.81658 16.5976 2.20711 16.2071L0.792893 14.7929ZM2.20711 16.2071L7.70711 10.7071L6.29289 9.29289L0.792893 14.7929L2.20711 16.2071Z"
        fill={color}
      />
      <path
        d="M18.5 7C17.9477 7 17.5 7.44772 17.5 8C17.5 8.55228 17.9477 9 18.5 9V7ZM22.5 8H23.5C23.5 7.44772 23.0523 7 22.5 7V8ZM21.5 12C21.5 12.5523 21.9477 13 22.5 13C23.0523 13 23.5 12.5523 23.5 12H21.5ZM18.5 9H22.5V7H18.5V9ZM21.5 8V12H23.5V8H21.5Z"
        fill={color}
      />
      <path
        d="M2.70711 10.2929C2.31658 9.90237 1.68342 9.90237 1.29289 10.2929C0.902369 10.6834 0.902369 11.3166 1.29289 11.7071L2.70711 10.2929ZM5.29289 15.7071C5.68342 16.0976 6.31658 16.0976 6.70711 15.7071C7.09763 15.3166 7.09763 14.6834 6.70711 14.2929L5.29289 15.7071ZM1.29289 11.7071L5.29289 15.7071L6.70711 14.2929L2.70711 10.2929L1.29289 11.7071Z"
        fill={color}
      />
    </svg>
  );
};

export default Gender;
